module.exports = __webpack_public_path__ + "static/img/card4.41b0c839.png";